import React, { useMemo } from 'react';
import { Tab, Tabs } from 'react-bootstrap';

import {
  GetEstimateByMonthWithItemsDto,
  GetProjectDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';
import FormSkeleton from '../../../app/components/FormSkeleton';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { ProjectEstimateItemsGrid } from './ProjectEstimateItemsGrid';
import { ProjectEstimateItemsWithClientsGrid } from './ProjectEstimateItemsWithClientsGrid';

interface ProjectSummaryTabProps {
  project?: GetProjectDto;
}

export const ProjectSummaryTab: React.FC<ProjectSummaryTabProps> = props => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('projectLng');
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [projectEstimateItems, setProjectEstimateItems] = React.useState<
    GetEstimateByMonthWithItemsDto[]
  >([]);

  useMemo(() => {
    setIsLoading(true);
    pok.estimatesByMonth
      .findWithItemsByProjectId(props.project?.id || '')
      .then(items => {
        setProjectEstimateItems(items);
        setIsLoading(false);
      })
      .catch(async errorResponse => {
        notifications.caughtError(errorResponse);
        setIsLoading(false);
      });
  }, [notifications, pok.estimatesByMonth, props.project?.id]);

  return (
    <div className="pt-4">
      {isLoading ? (
        <FormSkeleton />
      ) : (
        <Tabs>
          <Tab
            eventKey="summaryByEstimates"
            title={t(tk.projects.byProfiles)}
            className="m-3"
          >
            <ProjectEstimateItemsGrid
              data={projectEstimateItems}
              project={props.project}
            />
          </Tab>
          <Tab
            eventKey="summaryByPublishers"
            title={t(tk.projects.byPublishers)}
            className="m-3"
          >
            <ProjectEstimateItemsWithClientsGrid
              data={projectEstimateItems}
              project={props.project}
            />
          </Tab>
        </Tabs>
      )}
    </div>
  );
};
